(function () {
  var scrollTop = document.getElementById("scroll__top");
  if (!scrollTop) return;

  var FOOTER_HIDE_BUFFER = 220;

  function nearPageBottom() {
    var scrolledBottom = window.scrollY + window.innerHeight;
    var fullHeight = document.documentElement.scrollHeight;
    return scrolledBottom >= fullHeight - FOOTER_HIDE_BUFFER;
  }

  function updateVisibility() {
    if (window.scrollY > 300 && !nearPageBottom()) {
      scrollTop.classList.add("active");
    } else {
      scrollTop.classList.remove("active");
    }
  }

  scrollTop.addEventListener("click", function () {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  });

  window.addEventListener("scroll", updateVisibility, { passive: true });
  window.addEventListener("resize", updateVisibility);
  window.addEventListener("load", updateVisibility);
  updateVisibility();
})();
